"use strict";

var _regeneratorRuntime = require("/root/ui-api/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_TEXT_QUOTE_LENGTH = exports.MAX_PREVIEW_WIDTH = exports.MAX_PREVIEW_HEIGHT = exports.MAX_IMAGE_QUOTE_LENGTH = exports.DEFAULT_VERSION = exports.DEFAULT_APP = void 0;
exports.decode = decode;
exports.decodeMsgs = decodeMsgs;
exports.emptyPublicKey = void 0;
exports.encode = encode;
exports.encodeMsg = encodeMsg;
exports.makeDatedGroups = makeDatedGroups;
exports.makeQuoteMsg = makeQuoteMsg;
exports.newTextMsg = newTextMsg;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.number.is-integer.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.string.starts-with.js");

require("core-js/modules/es.object.values.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.function.name.js");

var _bytebuffer = _interopRequireDefault(require("bytebuffer"));

var _assert = _interopRequireDefault(require("assert"));

var _bs = _interopRequireDefault(require("bs58"));

var _debug = _interopRequireDefault(require("debug"));

var _truncate = _interopRequireDefault(require("lodash/truncate"));

var _ecc = require("./ecc");

var _serializer = require("./serializer");

var _api = _interopRequireDefault(require("../api"));

var _ = _interopRequireDefault(require("."));

var _utils = require("../utils");

var _promisify = require("../promisify");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e3) {
      didErr = true;
      err = _e3;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var isInteger = Number.isInteger;
/** @const {string} DEFAULT_APP 
    @default 'golos-messenger' */

var DEFAULT_APP = 'golos-messenger';
/** @const {string} DEFAULT_VERSION 
    @default 1 */

exports.DEFAULT_APP = DEFAULT_APP;
var DEFAULT_VERSION = 1;
/** @const {string} MAX_PREVIEW_WIDTH 
    @default 600 */

exports.DEFAULT_VERSION = DEFAULT_VERSION;
var MAX_PREVIEW_WIDTH = 600;
/** @const {string} MAX_PREVIEW_HEIGHT 
    @default 300 */

exports.MAX_PREVIEW_WIDTH = MAX_PREVIEW_WIDTH;
var MAX_PREVIEW_HEIGHT = 300;
/** @const {string} MAX_TEXT_QUOTE_LENGTH
    @default 200 */

exports.MAX_PREVIEW_HEIGHT = MAX_PREVIEW_HEIGHT;
var MAX_TEXT_QUOTE_LENGTH = 200;
/** @const {string} MAX_IMAGE_QUOTE_LENGTH
    @default 2000 */

exports.MAX_TEXT_QUOTE_LENGTH = MAX_TEXT_QUOTE_LENGTH;
var MAX_IMAGE_QUOTE_LENGTH = 2000;
exports.MAX_IMAGE_QUOTE_LENGTH = MAX_IMAGE_QUOTE_LENGTH;

var toPrivateObj = function toPrivateObj(o) {
  return o ? o.d ? o : _ecc.PrivateKey.fromWif(o) : o
  /*null or undefined*/
  ;
};

var toPublicObj = function toPublicObj(o) {
  return o ? o.Q ? o : _ecc.PublicKey.fromString(o) : o
  /*null or undefined*/
  ;
};

var emptyPublicKey = 'GLS1111111111111111111111111111111114T1Anm';
exports.emptyPublicKey = emptyPublicKey;
var debugMsgs = (0, _debug.default)('golos:messages');

function validateAppVersion(app, version) {
  (0, _assert.default)(typeof app === 'string' && app.length >= 1 && app.length <= 16, 'message.app should be a string, >= 1, <= 16');
  (0, _assert.default)(isInteger(version) && version >= 1, 'message.version should be an integer, >= 1');
}

function validateBody(body) {
  (0, _assert.default)(typeof body === 'string', 'message.body should be a string');
}

function validateImageMsg(msg) {
  (0, _assert.default)(isInteger(msg.previewWidth) && msg.previewWidth >= 1 && msg.previewWidth <= MAX_PREVIEW_WIDTH, 'message.previewWidth (for image) should be an integer, >= 1, <= ' + MAX_PREVIEW_WIDTH);
  (0, _assert.default)(isInteger(msg.previewHeight) && msg.previewHeight >= 1 && msg.previewHeight <= MAX_PREVIEW_HEIGHT, 'message.previewHeight (for image) should be an integer, >= 1, <= ' + MAX_PREVIEW_HEIGHT);
}

function validateMsgWithQuote(msg) {
  if (msg.quote !== undefined) {
    (0, _assert.default)(_typeof(msg.quote) === 'object', 'message.quote should be an object or undefined at all');
    (0, _assert.default)(typeof msg.quote.from === 'string' && msg.quote.from.length >= 1 && msg.quote.from.length <= 16, 'message.quote.from should be a valid nickname of sender of message, to which this reply is');
    (0, _assert.default)(typeof msg.quote.nonce === 'string' && msg.quote.nonce.length, 'message.quote.nonce should be a valid nonce of message, to which this reply is');

    if (msg.quote.type !== 'image') {
      (0, _assert.default)(typeof msg.quote.body === 'string' && msg.quote.body.length <= MAX_TEXT_QUOTE_LENGTH, 'message.quote.body should be a truncated (length <= 200) text of message, to which this reply is');
    } else {
      (0, _assert.default)(typeof msg.quote.body === 'string' && msg.quote.body.length <= MAX_IMAGE_QUOTE_LENGTH, 'message.quote.body should be a truncated (length <= 2000) image URL from message, to which this reply is');
    }
  }
}
/**
    Creates new message, which can be encoded by golos.messages.encode.
    @arg {string} text - text ("body") of the message.
    @arg {string} [app = DEFAULT_APP] - "app" field of the message. Should be a string with length from 1 to 16.
    @arg {string} [version = DEFAULT_VERSION] - "version" field of the message. Should be an integer, starting of 1.
    @throws {Exception} when supplied data is invalid.
    @return {object} - result message object.
*/


function newTextMsg(text) {
  var app = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_APP;
  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_VERSION;
  validateBody(text);
  validateAppVersion(app, version);
  var msg = {
    app: app,
    version: version,
    body: text
  };
  return msg;
}
/**
    Creates new image message, which can be encoded by golos.messages.encode.
    @arg {string} image_url - URL of the image in the Internet (please use https://, and store images in image hostings, to make them storing eternally). This URL will be a "body" of the message.
    @arg {function} callback - callback. Params are <code>(err, message)</code>. Calling after message construction (err is null in this case), or if error occured (err is exception, message is null).
    @arg {function} [on_progress = undefined] - progress callback. Params are <code>(percent, extra_data)</code>. Percent is integer from 1 to 100.
    @arg {string} [app = DEFAULT_APP] - "app" field of the message. Should be a string with length from 1 to 16.
    @arg {string} [version = DEFAULT_VERSION] - "version" field of the message. Should be an integer, starting of 1.
    @throws {Exception} only if callback called due error, and callback also throws error. So callback shouldn't throw errors.
*/


exports.newImageMsg = function (image_url, callback) {
  var on_progress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var app = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_APP;
  var version = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_VERSION;

  var reportProgress = function reportProgress(progress) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (on_progress) on_progress(progress, {
      error: error
    });
  };

  try {
    (0, _assert.default)(typeof Image !== 'undefined', 'Current environment does not support Image()');
    (0, _assert.default)(image_url, 'image_url is required');
    (0, _assert.default)(callback, 'callback is required');
    validateAppVersion(app, version);
    reportProgress(0);

    var reportLoadError = function reportLoadError(errorText) {
      var err = new Error(errorText);
      reportProgress(100, err);
      callback(err, null);
    };

    var img = new Image();
    var watchdog;

    var clearWatchdog = function clearWatchdog() {
      if (watchdog) clearTimeout(watchdog);
    };

    img.onerror = img.onabort = function () {
      clearWatchdog();
      reportLoadError('Cannot load image');
    };

    img.onload = function () {
      clearWatchdog();
      reportProgress(100);
      var previewSize = (0, _utils.fitImageToSize)(img.width, img.height, MAX_PREVIEW_WIDTH, MAX_PREVIEW_HEIGHT);
      var msg = {
        app: app,
        version: version,
        body: image_url,
        type: 'image',
        previewWidth: previewSize.width,
        previewHeight: previewSize.height
      };
      validateImageMsg(msg);
      callback(null, msg);
    };

    watchdog = setTimeout(function () {
      if (!img.complete) {
        img.onload = img.onerror = img.onabort = {};
        reportLoadError('Image load timed out, maybe it is too large');
      }
    }, 5000);
    img.src = image_url;
  } catch (err) {
    reportProgress(100, err);
    if (callback) callback(err, null);
  }
};
/**
    Creates new image message, which can be encoded by golos.messages.encode. Async version of function, should be called with await.
    @arg {string} image_url - URL of the image in the Internet. It will be a "body" of the message.
    @arg {function} [on_progress = undefined] - progress callback. Params are <code>(percent, extra_data)</code>. Percent is integer from 1 to 100.
    @arg {string} [app = DEFAULT_APP] - "app" field of the message. Should be a string with length from 1 to 16.
    @arg {string} [version = DEFAULT_VERSION] - "version" field of the message. Should be an integer, starting of 1.
    @throws {Exception} if error occured.
    @return {object} - result message object.
    @function newImageMsgAsync
*/


exports.newImageMsgAsync = (0, _promisify.promisify)(function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var callback = args[args.length - 1];

  var _args$slice = args.slice(0, args.length - 1),
      _args$slice2 = _slicedToArray(_args$slice, 4),
      image_url = _args$slice2[0],
      on_progress = _args$slice2[1],
      app = _args$slice2[2],
      version = _args$slice2[3];

  return exports.newImageMsg(image_url, callback, on_progress, app, version);
});
/**
    Makes your message the reply to another message_object. Call it after `newTextMsg`/`newImageMsg`/etc, next call `encode`, and finally send resulting message as usually.
    @arg {object} msg = Your message, created by `newTextMsg`, `newImageMsg`, etc.
    @arg {object} quoted_message_object = Message to which you want to reply. It should be one of messages returned by `golos.messages.decode`, and have "from", "nonce", and (warning!) "message". If message is invalid (cannot be decoded), it has no "message" field, and if you try reply it, it will throw.
    @throws {Exception} if quoted_message_object is invalid.
    @return {object} - result message object, which can be encoded and sent.
    @function newImageMsgAsync
*/

function makeQuoteMsg(msg, quoted_message_object) {
  (0, _assert.default)(quoted_message_object, 'quoted_message_object is required');
  var assertPrefix = 'quoted_message_object should be one of VALID objects, returned by `golos.messages.decode`';
  (0, _assert.default)(quoted_message_object.from, "".concat(assertPrefix, ", and have \"from\" field"));
  (0, _assert.default)(quoted_message_object.nonce, "".concat(assertPrefix, ", and have \"nonce\" field"));
  (0, _assert.default)(quoted_message_object.message, "".concat(assertPrefix, ", and have \"message\" field"));
  (0, _assert.default)(quoted_message_object.message.body, "".concat(assertPrefix, ", and have \"message\" field with \"body\""));
  var type = quoted_message_object.message.type;
  var body = quoted_message_object.message.body;

  if (type !== 'image') {
    body = (0, _truncate.default)(body, {
      length: MAX_TEXT_QUOTE_LENGTH,
      omission: '...'
    });
  } else {
    if (body.length > MAX_IMAGE_QUOTE_LENGTH) {
      body = (0, _truncate.default)(body, {
        length: MAX_TEXT_QUOTE_LENGTH,
        omission: '...'
      });
      type = undefined; // make it text
    }
  }

  if (!msg) msg = {};
  msg.quote = {
    from: quoted_message_object.from,
    nonce: quoted_message_object.nonce,
    body: body
  };
  if (type) msg.quote.type = type;
  return msg;
}

function forEachMessage(message_objects, begin_idx, end_idx, callback) {
  if (begin_idx === undefined) begin_idx = 0;
  if (end_idx === undefined) end_idx = message_objects.length;
  var step = end_idx > begin_idx ? 1 : -1;

  for (var _i2 = begin_idx; _i2 != end_idx; _i2 += step) {
    var message_object = message_objects[_i2]; // return true is `continue`
    // return false is `break`

    if (!callback(message_object, _i2)) break;
  }
}

function msgFromBuf(buf) {
  var lengthPrefixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var toUTF8String = function toUTF8String() {
    return new Buffer(buf.toString('binary'), 'binary').toString('utf-8');
  };

  if (!lengthPrefixed) {
    // Used in groups. Prefixed used in private chats
    buf.mark();
    return toUTF8String();
  }

  var rawMsg;

  try {
    buf.mark();
    rawMsg = buf.readVString();
  } catch (e) {
    buf.reset(); // Sender did not length-prefix the message

    rawMsg = toUTF8String();
  }

  return rawMsg;
}

function msgFromHex(hex) {
  var lengthPrefixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var buf = _bytebuffer.default.fromHex(hex, _bytebuffer.default.LITTLE_ENDIAN);

  return msgFromBuf(buf, lengthPrefixed);
}

var parseMsg = function parseMsg(message, rawMsg) {
  var raw_messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  message.raw_message = rawMsg;
  message.decrypt_date = message.receive_date;

  if (!raw_messages) {
    var msg = JSON.parse(message.raw_message);
    msg.type = msg.type || 'text';
    validateBody(msg.body);
    if (msg.type === 'image') validateImageMsg(msg);
    validateAppVersion(msg.app, msg.version);
    validateMsgWithQuote(msg);
    message.message = msg;
  }
};

var parseQuery = function parseQuery(query) {
  (0, _assert.default)(query && _typeof(query) === 'object' && !Array.isArray(query), 'argument should be an object with argument-field. See golos-lib-js documentation.');
  return query;
};

var warnDeprecation = function warnDeprecation(oldMethod, newMethod) {
  console.warn("golos.messages.".concat(oldMethod, " deprecated. ") + "It is not async, not supports groups, etc. " + "Will be removed in future. Migrate to golos.messages.".concat(newMethod, "."));
};
/**
    Decodes messages of format used by golos.messages.encode(), which are length-prefixed, and also messages sent by another way (not length-prefixed).<br>
    Also, parses (JSON) and validates each message (app, version...). (Invalid messages are also added to result, it is need to mark them as read. To change it, use <code>on_error</code>).<br>
    Processes whole incoming array, or only part of it.<br>
    Can process in reversed order.
    @arg {string|PrivateKey} private_memo_key - private memo key of "from" or "to".
    @arg {string|PublicKey} second_user_public_memo_key - public memo key of second user.
    @arg {array} message_objects - array of objects. Each object should contain nonce, checksum and encrypted_message (such object returns from private_message API).
    @arg {function} [before_decode = undefined] - callback, calling on each message before processing. Params are <code>(message, idx, results)</code>. If returns true, message will not be processed. Also, you can push it to <code>results</code> manually.
    @arg {function} [for_each = undefined] - callback, calling on each message, after message is decoded, parsed and validated, but before add it to result array. Params are <code>(message, idx)</code>. If returns true, message willn't be added to result array.
    @arg {function} [on_error = undefined] - callback, calling on each message which can't be decrypted, parsed, validated, or if <code>for_each</code> throws. Params are <code>(message, idx, exception)</code>. If returns true, message willn't be added to result array.
    @arg {int} [begin_idx = undefined] - if set, function will process messages only from this index (incl.). If begin_idx > end_idx, messages will be processed in reversed order.
    @arg {int} [end_idx = undefined] - if set, function will process messages only before this index (excl.). If end_idx < begin_idx, messages will be processed in reversed order.
    @arg {bool} [raw_messages = false] - if set, function will not parse messages as JSON and validate them.
    @return {array} - result array of message_objects. Each object has "message" and "raw_message" fields. If message is invalid, it has only "raw_message" field. And if message cannot be decoded at all, it hasn't any of these fields.
*/


function decode(private_memo_key, second_user_public_memo_key, message_objects) {
  var before_decode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var for_each = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var on_error = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  var begin_idx = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
  var end_idx = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;
  var raw_messages = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  warnDeprecation('decode', 'decodeMsgs');
  (0, _assert.default)(private_memo_key, 'private_memo_key is required');
  (0, _assert.default)(second_user_public_memo_key, 'second_user_public_memo_key is required');
  (0, _assert.default)(message_objects, 'message_objects is required');
  var private_key = toPrivateObj(private_memo_key);
  var public_key = toPublicObj(second_user_public_memo_key);
  var shared_secret;
  var results = [];
  forEachMessage(message_objects, begin_idx, end_idx, function (message_object, i) {
    // Return true if for_each should not be called
    var processOnError = function processOnError(exception) {
      if (on_error) {
        if (!on_error(message_object, i, exception)) {
          results.push(message_object);
        }

        return true;
      }

      return false;
    };

    try {
      message_object.raw_message = null; // Will be set if message will be successfully decoded

      message_object.message = null; // Will be set if message will be also successfully parsed and validated

      if (before_decode && before_decode(message_object, i, results)) {
        return true;
      } // Most "heavy" line


      if (!shared_secret) shared_secret = private_key.get_shared_secret(public_key);

      var decrypted = _ecc.Aes.decrypt(shared_secret, null, message_object.nonce.toString(), Buffer.from(message_object.encrypted_message, 'hex'), message_object.checksum);

      var mbuf = _bytebuffer.default.fromBinary(decrypted.toString('binary'), _bytebuffer.default.DEFAULT_CAPACITY, _bytebuffer.default.LITTLE_ENDIAN);

      decrypted = msgFromBuf(mbuf, true);
      parseMsg(message_object, decrypted, raw_messages);
    } catch (exception) {
      if (processOnError(exception)) return true;
    }

    try {
      if (!for_each || !for_each(message_object, i)) {
        results.push(message_object);
      }
    } catch (exception) {
      processOnError(exception);
    }

    return true;
  });
  return results;
}

var ExceptionTypes = {
  NodeError: 1,
  Error: 2,
  OuterError: 3,
  RequestError: 4
};

function decodeMsgs(_x) {
  return _decodeMsgs.apply(this, arguments);
}
/**
    Encodes message to send with private_message_operation. Converts object to JSON string. Uses writeVString, so format of data to encode is string length + string.
    @arg {string|PrivateKey} from_private_memo_key - private memo key of "from"
    @arg {string|PublicKey} to_public_memo_key - private memo key of "to"
    @arg {object} message - message to encode.
    @arg {string|undefined} nonce - unique identifier of message. When editing message, set to its nonce. Otherwise keep undefined.
    @return {object} - Object with fields: nonce, checksum and message.
*/


function _decodeMsgs() {
  _decodeMsgs = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(query) {
    var _parseQuery, msgs, before_decode, for_each, on_error, raw_messages, private_memo, api, login, begin_idx, end_idx, private_key, myPublic, shareds, results, entriesDec, entries, decRes, decErr, dgp, account, keys, sessionName, processOnError, idxs, j, _i3, msg, proceedId, ex, _ex, dec, _ex2;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _parseQuery = parseQuery(query), msgs = _parseQuery.msgs, before_decode = _parseQuery.before_decode, for_each = _parseQuery.for_each, on_error = _parseQuery.on_error, raw_messages = _parseQuery.raw_messages, private_memo = _parseQuery.private_memo, api = _parseQuery.api, login = _parseQuery.login, begin_idx = _parseQuery.begin_idx, end_idx = _parseQuery.end_idx;
            (0, _assert.default)(msgs, 'msgs is required');
            private_key = private_memo && toPrivateObj(private_memo);
            myPublic = private_key && private_key.toPublic().toString();
            shareds = {};
            results = [];
            entriesDec = {};
            forEachMessage(msgs, begin_idx, end_idx, function (message, i) {
              // Return true if for_each should not be called
              var processOnError = function processOnError(exception) {
                var exType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ExceptionTypes.Error;

                if (on_error) {
                  if (!on_error(message, i, exception, exType)) {
                    results.push(message);
                  }

                  return true;
                }

                console.warn('golos.messages.decodeMsgs', i, exception);
                return false;
              };

              try {
                if (!message.group || message.decrypt_date !== message.receive_date) {
                  message.raw_message = null; // Will be set if message will be successfully decoded

                  message.message = null; // Will be set if message will be also successfully parsed and validated
                }

                if (before_decode && before_decode(message, i, results)) {
                  return true;
                }

                if (!message.group) {
                  var pubKey = message.from_memo_key === myPublic ? message.to_memo_key : message.from_memo_key; // Most "heavy" line (in private chats)

                  if (!shareds[pubKey]) {
                    shareds[pubKey] = private_key.get_shared_secret(toPublicObj(pubKey));
                  }

                  var decrypted = _ecc.Aes.decrypt(shareds[pubKey], null, message.nonce.toString(), Buffer.from(message.encrypted_message, 'hex'), message.checksum);

                  var mbuf = _bytebuffer.default.fromBinary(decrypted.toString('binary'), _bytebuffer.default.DEFAULT_CAPACITY, _bytebuffer.default.LITTLE_ENDIAN);

                  decrypted = msgFromBuf(mbuf, true);
                  parseMsg(message, decrypted, raw_messages);
                  message.decryptor = 'golos-lib';
                } else {
                  var rawMsg = msgFromHex(message.encrypted_message);
                  var isEncrypted = rawMsg.startsWith('{"t":"em"');

                  if (isEncrypted) {
                    if (!message.decrypted || message.decrypt_date !== message.receive_date) {
                      entriesDec[i] = {
                        group: message.group,
                        encrypted_message: message.encrypted_message
                      };
                      results.push(message);
                      return true;
                    }

                    rawMsg = msgFromHex(message.decrypted);
                  }

                  parseMsg(message, rawMsg, raw_messages);
                }
              } catch (exception) {
                if (processOnError(exception)) return true;
              }

              try {
                if (!for_each || !for_each(message, i)) {
                  results.push(message);
                }
              } catch (exception) {
                console.error(exception);
                processOnError(exception, ExceptionTypes.OuterError);
              }

              return true;
            });
            entries = Object.values(entriesDec);

            if (!entries.length) {
              _context2.next = 64;
              break;
            }

            if (!api) {
              api = _api.default;
            }

            _context2.prev = 11;
            debugMsgs('decryptMessagesAsync', entries.length + ' msgs');
            dgp = login.dgp, account = login.account, keys = login.keys, sessionName = login.sessionName;
            _context2.next = 16;
            return _.default.withNodeLogin({
              account: account,
              keys: keys,
              sessionName: sessionName,
              dgp: dgp,
              call: function () {
                var _call = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee(loginData) {
                  var decRes;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return api.decryptMessagesAsync(_objectSpread(_objectSpread({}, loginData), {}, {
                            entries: entries
                          }));

                        case 2:
                          decRes = _context.sent;
                          return _context.abrupt("return", decRes);

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                function call(_x3) {
                  return _call.apply(this, arguments);
                }

                return call;
              }()
            });

          case 16:
            decRes = _context2.sent;
            _context2.next = 22;
            break;

          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](11);
            decErr = _context2.t0;

          case 22:
            debugMsgs('decryptMessagesAsync', entries.length + ' msgs'); // Return true if for_each should not be called

            processOnError = function processOnError(msg, idx, exception) {
              var exType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ExceptionTypes.NodeError;

              if (on_error) {
                if (on_error(msg, idx, exception, exType)) {
                  msg.ignore = true;
                }

                return true;
              }

              console.warn('golos.messages.decodeMsgs', i, exception);
              return false;
            };

            idxs = Object.keys(entriesDec);
            j = 0;

          case 26:
            if (!(j < entries.length)) {
              _context2.next = 64;
              break;
            }

            _i3 = idxs[j];
            msg = msgs[_i3];
            _context2.prev = 29;
            proceedId = true;

            if (decRes) {
              _context2.next = 38;
              break;
            }

            proceedId = false;
            ex = new Error(decErr && decErr.message || 'Unknown error');

            if (!processOnError(msg, _i3, decErr, ExceptionTypes.RequestError)) {
              _context2.next = 36;
              break;
            }

            return _context2.abrupt("continue", 61);

          case 36:
            _context2.next = 43;
            break;

          case 38:
            if (!(decRes.status !== 'ok' || !decRes.results)) {
              _context2.next = 43;
              break;
            }

            proceedId = false;
            _ex = new Error(decRes.err || 'Unknown error');

            if (!processOnError(msg, _i3, _ex)) {
              _context2.next = 43;
              break;
            }

            return _context2.abrupt("continue", 61);

          case 43:
            if (!proceedId) {
              _context2.next = 54;
              break;
            }

            dec = decRes.results[j];

            if (!(dec && dec.body)) {
              _context2.next = 51;
              break;
            }

            dec.decrypted = dec.body; // TODO: but `decrypted` should be hex

            parseMsg(msg, dec.decrypted, raw_messages);
            msg.decryptor = 'node/decrypt_messages';
            _context2.next = 54;
            break;

          case 51:
            _ex2 = new Error(dec.err || (!dec ? ' No decrypt result' : 'No body') + ', unknown error');

            if (!processOnError(msg, _i3, _ex2)) {
              _context2.next = 54;
              break;
            }

            return _context2.abrupt("continue", 61);

          case 54:
            _context2.next = 60;
            break;

          case 56:
            _context2.prev = 56;
            _context2.t1 = _context2["catch"](29);

            if (!processOnError(msg, _i3, exception, ExceptionTypes.Error)) {
              _context2.next = 60;
              break;
            }

            return _context2.abrupt("continue", 61);

          case 60:
            try {
              if (!msg.ignore && for_each && for_each(msg, _i3)) {
                msg.ignore = true;
              }
            } catch (exception) {
              console.error(exception);
              processOnError(exception, ExceptionTypes.OuterError);
            }

          case 61:
            ++j;
            _context2.next = 26;
            break;

          case 64:
            results = results.filter(function (res) {
              return !res.ignore;
            });
            return _context2.abrupt("return", results);

          case 66:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[11, 19], [29, 56]]);
  }));
  return _decodeMsgs.apply(this, arguments);
}

function encode(from_private_memo_key, to_public_memo_key, message) {
  var nonce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  warnDeprecation('encode', 'encodeMsg');
  (0, _assert.default)(from_private_memo_key, 'from_private_memo_key is required');
  (0, _assert.default)(to_public_memo_key, 'to_public_memo_key is required');
  (0, _assert.default)(message, 'message is required');
  var fromKey = toPrivateObj(from_private_memo_key);
  var toKey = toPublicObj(to_public_memo_key);
  var mbuf = new _bytebuffer.default(_bytebuffer.default.DEFAULT_CAPACITY, _bytebuffer.default.LITTLE_ENDIAN);
  mbuf.writeVString(JSON.stringify(message));
  message = new Buffer(mbuf.copy(0, mbuf.offset).toBinary(), 'binary');

  var data = _ecc.Aes.encrypt(fromKey, toKey, message, nonce);

  return {
    nonce: data.nonce.toString(),
    encrypted_message: data.message.toString('hex'),
    checksum: data.checksum
  };
}

function encodeMsg(_x2) {
  return _encodeMsg.apply(this, arguments);
}
/**
    Selects messages by condition (e.g unread, or selected by user), and groups them into ranges with `nonce` (if range has 1 message) or `start_date`+`stop_date` (if range has few messages). Can wrap these ranges into operations: `private_mark_message` and `private_delete_message`.
    @arg {array} message_objects - array of message objects. It can be result array from `golos.messages.decode`.
    @arg {function} condition - callback, calling on each message. Params are (message, idx). If returns true, message is adding to ranges. If returns false/undefined/null, message is skipping. If returns -1, processing loop breaks.
    @arg {function} wrapper - callback, calling on each range, when adding it to result array. Allows to wrap range as an operation. Params are (range). Should return wrapped result. If returns false/undefined/null, range skipping.
    @arg {int|undefined} begin_idx - if set, function will process messages only from it index (incl.). If begin_idx > end_idx, messages will be processed in reversed order.
    @arg {int|undefined} end_idx - if set, function will process messages only before it index (excl.). If end_idx < begin_idx, messages will be processed in reversed order.
    @return {array} - result array of operations, which can be sent in single transaction.
*/


function _encodeMsg() {
  _encodeMsg = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(_ref) {
    var group, private_memo, to_public_memo, msg, nonce, api, msgToBuffer, fromKey, toKey, data, body, res, newBody, encrypted_message;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            group = _ref.group, private_memo = _ref.private_memo, to_public_memo = _ref.to_public_memo, msg = _ref.msg, nonce = _ref.nonce, api = _ref.api;
            (0, _assert.default)(msg, 'msg is required');

            msgToBuffer = function msgToBuffer(msg) {
              var mbuf = new _bytebuffer.default(_bytebuffer.default.DEFAULT_CAPACITY, _bytebuffer.default.LITTLE_ENDIAN);

              if (group) {
                mbuf.writeUTF8String(JSON.stringify(msg));
              } else {
                mbuf.writeVString(JSON.stringify(msg));
              }

              msg = new Buffer(mbuf.copy(0, mbuf.offset).toBinary(), 'binary');
              return msg;
            };

            if (group) {
              _context3.next = 11;
              break;
            }

            (0, _assert.default)(private_memo, 'private_memo is required in private chats');
            (0, _assert.default)(to_public_memo, 'to_public_memo is required in private chats');
            fromKey = toPrivateObj(private_memo);
            toKey = toPublicObj(to_public_memo);
            msg = msgToBuffer(msg);
            data = _ecc.Aes.encrypt(fromKey, toKey, msg, nonce);
            return _context3.abrupt("return", {
              nonce: data.nonce.toString(),
              encrypted_message: data.message.toString('hex'),
              checksum: data.checksum,
              from_memo_key: fromKey.toPublic().toString(),
              to_memo_key: to_public_memo
            });

          case 11:
            (0, _assert.default)(!private_memo, 'private_memo is for private messages, not groups');
            (0, _assert.default)(!to_public_memo, 'to_public_memo is for private messages, not groups');

            if (!group.is_encrypted) {
              _context3.next = 29;
              break;
            }

            if (!api) {
              api = _api.default;
            }

            body = JSON.stringify(msg);
            debugMsgs('encryptBodyAsync');
            _context3.next = 19;
            return api.encryptBodyAsync({
              group: group.name,
              body: body
            });

          case 19:
            res = _context3.sent;
            debugMsgs('encryptBodyAsync');

            if (!res.error) {
              _context3.next = 23;
              break;
            }

            throw new Error(res.error);

          case 23:
            newBody = {};
            newBody.t = 'em';
            newBody.c = res.encrypted;
            msg = msgToBuffer(newBody);
            _context3.next = 30;
            break;

          case 29:
            msg = msgToBuffer(msg);

          case 30:
            encrypted_message = msg.toString('hex');
            return _context3.abrupt("return", {
              nonce: nonce || _ecc.Aes.uniqueNonce().toString(),
              encrypted_message: encrypted_message,
              checksum: 0,
              from_memo_key: emptyPublicKey,
              to_memo_key: emptyPublicKey
            });

          case 32:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _encodeMsg.apply(this, arguments);
}

function makeDatedGroups(message_objects, condition, wrapper, begin_idx, end_idx) {
  (0, _assert.default)(message_objects, 'message_objects is required');
  (0, _assert.default)(condition, 'condition is required');
  (0, _assert.default)(wrapper, 'wrapper is required');
  var results = [];
  var group = null;
  var before = null;

  var fixStartDate = function fixStartDate(start_date) {
    return new Date(new Date(start_date + 'Z').getTime() - 1000).toISOString().split('.')[0];
  };

  var time_point_min = '1970-01-01T00:00:00';

  var pushResult = function pushResult(nonces, msgs, start_date, stop_date) {
    if (nonces) {
      var _iterator = _createForOfIteratorHelper(nonces),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var nonce = _step.value;
          var msg = msgs[nonce];
          var from = msg.from,
              to = msg.to;
          var wrapped = wrapper({
            start_date: time_point_min,
            stop_date: time_point_min,
            nonce: nonce,
            from: from,
            to: to
          });
          if (wrapped) results.push(wrapped);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      var _wrapped = wrapper({
        start_date: start_date,
        stop_date: stop_date,
        nonce: 0
      });

      if (_wrapped) results.push(_wrapped);
    }
  };

  var pushGroup = function pushGroup(nextCreateDate) {
    if (!group) return;
    var _group = group,
        beforeNonces = _group.beforeNonces,
        nonces = _group.nonces,
        afterNonces = _group.afterNonces,
        msgs = _group.msgs;

    if (!nextCreateDate || nextCreateDate !== group.start_date) {
      nonces.push.apply(nonces, _toConsumableArray(afterNonces));
      afterNonces = [];
    }

    pushResult(beforeNonces, msgs);

    if (nonces.length > 1) {
      if (!afterNonces.length) group.start_date = fixStartDate(group.start_date);
      pushResult(null, msgs, group.start_date, group.stop_date);
    } else if (nonces[0]) {
      pushResult([nonces[0]], msgs);
    }

    pushResult(afterNonces, msgs);
    group = null;
  };

  forEachMessage(message_objects, begin_idx, end_idx, function (message_object, i) {
    var cond = condition(message_object, i);
    var create_date = message_object.create_date,
        nonce = message_object.nonce;

    if (cond === -1) {
      return false;
    } else if (cond) {
      if (!group) {
        group = {
          stop_date: create_date,
          beforeNonces: [],
          afterNonces: [],
          nonces: [],
          msgs: {}
        };
      }

      if (create_date === before) {
        group.beforeNonces.push(nonce);
      } else {
        if (before) {
          before = null;
          group.stop_date = create_date;
        }

        if (create_date !== group.start_date) {
          var _group$nonces;

          (_group$nonces = group.nonces).push.apply(_group$nonces, _toConsumableArray(group.afterNonces));

          group.afterNonces = [];
        }

        group.afterNonces.push(nonce);
      }

      group.start_date = create_date;
      group.msgs[nonce] = message_object;
    } else if (cond === false) {
      pushGroup(create_date);
      before = create_date;
    }

    return true;
  });
  pushGroup();
  return results;
}